module.exports = __webpack_public_path__ + "img/arrow-circle-up.7b0969d2.svg";